<template>
	<div class="container">
		<div class="contents">
			<div class="info-box">
				<p class="part-title">{{ text }}</p>
				<p class="info-title color-gray">등록해 주신 정보 확인하여<br />빠른 시일 내에 전화드리겠습니다.<br />감사합니다.</p>
			</div>
			<div class="btn-box">
				<button class="btn big yellow radius" @click="closeWindow">확인</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Complete',
	components: {},
	filters: {},
	mixins: [],
	extends: {},
	props: {},
	data() {
		return {};
	},
	computed: {
		text() {
			const key = this.$route.query.t || 'cargo';
			const map = {
				cargo: '차고지 신청이 완료되었습니다.',
				monthly: '월주차 신청이 완료되었습니다.'
			};

			return map[key];
		}
	},
	watch: {},
	methods: {
		closeWindow() {
			window.close();
		}
	},
	beforeCreate() {},
	created() {},
	beforeMount() {},
	mounted() {},
	beforeUpdate() {},
	updated() {},
	beforeDestroy() {},
	destroyed() {}
};
</script>

<style lang="scss" scoped>
.container {
	position: relative;

	.contents {
		position: fixed;
		top: 50%;
		right: 0;
		left: 0;
		margin: 0 auto;
		-webkit-transform: translate(0, -50%);
		transform: translate(0, -50%);
		text-align: center;
	}
}

.info-box {
	border-bottom: none;
}
</style>
